import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableTdActionFn = /* @__PURE__ */ createRecipe('table-td-action', {}, [])

const tableTdActionVariantMap = {}

const tableTdActionVariantKeys = Object.keys(tableTdActionVariantMap)

export const tableTdAction = /* @__PURE__ */ Object.assign(memo(tableTdActionFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableTdAction',
  __getCompoundVariantCss__: tableTdActionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableTdActionVariantKeys,
  variantMap: tableTdActionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableTdActionVariantKeys)
  },
  getVariantProps: tableTdActionFn.getVariantProps,
})